import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useUnleashContext } from "@unleash/proxy-client-react";
import { RootState } from "../redux/store";
import { TUser } from "../types/type";

function isUsableEmail(value?: string | null): value is string {
  return typeof value === "string" && value.includes("@") && !value.includes("tmp_");
}

export function resolveUnleashUserEmail(user?: TUser): string | undefined {
  const candidates = [user?.email, user?.username, user?.summary?.email];
  const email = candidates.find(isUsableEmail);
  return email ? email.trim() : undefined;
}

function UnleashUserContext() {
  const updateContext = useUnleashContext();
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const email = resolveUnleashUserEmail(user);
  const sub = user?.sub;
  const hasUserContext = useRef(false);

  useEffect(() => {
    if (isAuthenticated && (email || sub)) {
      hasUserContext.current = true;
      updateContext({ userId: sub, properties: email ? { userEmail: email } : {} });
      return;
    }
    if (hasUserContext.current) {
      hasUserContext.current = false;
      updateContext({});
    }
  }, [isAuthenticated, email, sub, updateContext]);

  return null;
}

export default UnleashUserContext;
